import { useRef, useState } from "react";

import { BdsFloat, BdsFloatAlign, BdsIconInfoCircle } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";

import UserInfoViewDisplay from "./UserInfoViewDisplay";

export interface ISpecificationInfoButtonProps {
    id: string;
    createdBy?: string;
    createdDate?: Date;
    lastUpdatedBy?: string;
    lastUpdatedDate?: Date;
}

export const SpecificationInfoButton: React.FC<ISpecificationInfoButtonProps> = ({
    createdBy,
    createdDate,
    lastUpdatedBy,
    lastUpdatedDate,
}) => {
    const infoIconRef = useRef<HTMLElement>(null);
    const [infoPopover, setInfoPopover] = useState(false);

    const onInfoClick = () => {
        setInfoPopover((open) => !open);
    };

    return (
        <>
            <span ref={infoIconRef} data-testid="specification-info-icon">
                <BTButton
                    id="specification-info-button"
                    data-testid="specification-info-button"
                    icon={<BdsIconInfoCircle />}
                    onClick={onInfoClick}
                    type="tertiary"
                    aria-label="Info"
                />
            </span>
            <BdsFloat
                source={infoIconRef}
                open={infoPopover}
                align={BdsFloatAlign.TR}
                ariaLabel="specificationInfoFloat"
                testid="specificationInfoFloat"
                className="specificationInfoFloat"
                role="tooltip"
                setOpen={setInfoPopover}
            >
                <div className="flex flex-row gap-2">
                    <UserInfoViewDisplay
                        addedByUserName={createdBy}
                        addedByUserDate={createdDate}
                        updatedByUserName={lastUpdatedBy}
                        updatedByUserDate={lastUpdatedDate}
                    />
                </div>
            </BdsFloat>
        </>
    );
};
